<template>
  <v-card
    tag="article"
    :to="to"
    class="article-card-featured d-flex white--text"
    flat
    tile
  >
    <img
      :src="files + img + '?resize=1&w=320'"
      :alt="title"
      loading="lazy"
      @error="invalidImage = true"
    />
    <div
      class="
        article-card-featured-content
        px-10
        pb-5
        d-flex
        flex-column
        justify-end
        align-start
      "
    >
      <v-btn
        v-if="categoryTitle"
        :to="categoryTo"
        :color="categoryColor"
        class="white--text mb-1 text-caption rounded-sm"
        x-small
        depressed
      >
        <span class="roboto-condensed">
          {{ categoryTitle }}
        </span>
      </v-btn>
      <h2 class="text-h6 font-weight-black">{{ title }}</h2>
      <time
        class="text-body-2 grey--text text--lighten-2"
        v-if="localeDate"
        :datetime="ISODate"
      >
        {{ localeDate }}
      </time>
    </div>
  </v-card>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    img: {
      type: String,
      required: true,
    },
    categoryTitle: {
      type: String,
    },
    categoryColor: {
      type: String,
    },
    categoryTo: {
      type: String,
    },
    to: {
      type: String,
      required: true,
    },
    ISODate: {
      type: String,
      required: true,
    },
    localeDate: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    invalidImage: false,
  }),
};
</script>

<style>
.article-card-featured {
  position: relative;
  aspect-ratio: 16/11;
  overflow: hidden;
}
.article-card-featured-content {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, #2f2f2f 100%);
}

.article-card-featured img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: 0.3s;
}
.article-card-featured h2 {
  line-height: 30px !important;
}
.article-card-featured:hover img {
  transform: scale(1.1);
}
</style>
